;
(function ($) {
  var dataKey = 'app.paysteps-navigator';
  var PayStepsNavigator = function PayStepsNavigator($steps) {
    this.init($steps);
  };
  PayStepsNavigator.prototype = {
    settings: {
      template: '<div class="payment-navigator-item payment-navigator-item--disabled">' + '<span class="payment-navigator-item__header"></span>' + '<span class="payment-navigator-item__pin"></span>' + '</div>',
      scrollOffset: -100,
      speed: 500,
      offset: 50,
      endpoint: 0
    },
    attr: {
      payStep: 'data-payment-step',
      payStepHeader: 'data-payment-header',
      payStepTitle: 'data-payment-title',
      nav: 'data-payment-navigation',
      key: 'data-payment-key',
      endPoint: 'data-payment-endpoint',
      backToMethod: 'data-back-to-method'
    },
    classes: {
      navUnstick: 'payment-navigator--unstick',
      navItem: 'payment-navigator-item',
      navItemHeader: 'payment-navigator-item__header',
      navItemDisabled: 'payment-navigator-item--disabled',
      navItemBlocked: 'payment-navigator-item--blocked',
      navItemActive: 'payment-navigator-item--active',
      navItemVisited: 'payment-navigator-item--visited',
      payStepActive: 'payment-step--active',
      payStepVisited: 'payment-step--visited',
      payStepConfirmed: 'payment-step--confirmed',
      payStepBlocked: 'payment-step--blocked'
    },
    /**
     * Initialise Payment Step Navigator
     * @public
     * @constructor
     * @param {selector} $steps - Payment steps container brought forward from the jquery.paystep.js plugin.
     */

    init: function init($steps) {
      var $nav = $('[' + this.attr.nav + ']');
      this._buildPayStepNavigation($steps, $nav);
      this._onWindowsScroll($nav);
    },
    /**
     * Build Pay Step Navigation
     * For each step found, apply the step template to the step navigator.
     * @private
     * @param {selector} $steps - Payment steps container.
     * @param {selector} $nav - Payment Step Navigator element.
     */

    _buildPayStepNavigation: function _buildPayStepNavigation($steps, $nav) {
      var _this = this;
      this._clearNavigation($nav);
      $steps.find('[' + this.attr.payStep + ']').each(function () {
        var key = _this._getNavigationStepKey($(this));
        $nav.append(_this.settings.template);
        _this._setNavigationStepKey($nav, key);
        _this._setNavigationStepHeader($nav, $(this));
        _this._setNavigationStepStatus($nav, $(this));
      });
      this._setBackToMethodAttr($nav);
      this._setNavigationHeight($nav);
      this._stepClickEventListener($steps, $nav);
    },
    /**
     * Clear Navigation
     * Removes all inner html from the payment step navigator.
     * @private
     * @param {selector} $nav - Payment Step Navigator element.
     */

    _clearNavigation: function _clearNavigation($nav) {
      $nav.html('');
    },
    /**
     * Payment Navigator Step Click Event Listener
     * Listens for a mouse click event on the payment step navigator pins.
     * Listens for a key press (spacebar) on the payment step navigator pins. This is for accessibility purposes.
     * @private
     * @param {selector} $steps - Payment steps container.
     * @param {selector} $nav - Payment Step Navigator element.
     */

    _stepClickEventListener: function _stepClickEventListener($steps, $nav) {
      var _this = this;
      $nav.find('[' + this.attr.key + ']').each(function () {
        if (!$(this).hasClass(_this.classes.navItemDisabled)) {
          $(this).on('click', function () {
            if (!$(this).hasClass(_this.classes.navItemBlocked)) {
              _this._scrollToPaymentStep($steps, $nav, $(this));
            }
          });
          $(this).bind('keypress', function (e) {
            if (e.keyCode === 32) {
              if (!$(this).hasClass(_this.classes.navItemBlocked)) {
                _this._scrollToPaymentStep($steps, $nav, $(this));
                return false;
              }
            }
          });
        }
      });
    },
    /**
     * Scroll To Payment Step
     * Scrolls the browser to the selected payment step.
     * @private
     * @param {selector} $steps - Payment steps container.
     * @param {selector} $nav - Payment Step Navigator element.
     * @param {selector} $step - The selected payment step on the navigator.
     */

    _scrollToPaymentStep: function _scrollToPaymentStep($steps, $nav, $step) {
      var _this = this;
      var key = $step.attr(_this.attr.key);
      var $target = $('[' + this.attr.payStep + '="' + key + '"]');
      var $previousNavStep = $(_this._getNavigationActiveStep($nav));
      this._updatePreviousPaymentStep($steps, $previousNavStep);
      $target.addClass(this.classes.payStepActive);
      if ($target.hasClass(this.classes.payStepVisited)) {
        $target.removeClass(this.classes.payStepVisited);
      }
      $previousNavStep.removeClass(this.classes.navItemActive);
      _this._setNavigationStepActive($('[' + _this.attr.key + '="' + key + '"]'));
      this.settings.endpoint = $('[' + this.attr.endPoint + ']').position().top;
      $('html, body').animate({
        scrollTop: $target.offset().top + _this.settings.scrollOffset
      }, _this.settings.speed);
    },
    /**
     * Update Previous Payment Step
     * Updates the previous payment step status depending on it's original state.
     * @private
     * @param {selector} $steps - Payment steps container.
     * @param {selector} $previousNavStep - The previously active payment step on the navigator.
     */

    _updatePreviousPaymentStep: function _updatePreviousPaymentStep($steps, $previousNavStep) {
      var paymentStep = $steps.find('.' + this.classes.payStepActive);
      if (!paymentStep.hasClass(this.classes.payStepConfirmed)) {
        paymentStep.addClass(this.classes.payStepVisited);
        $previousNavStep.addClass(this.classes.navItemVisited);
      }
      paymentStep.removeClass(this.classes.payStepActive);
    },
    /**
     * On Windows Scroll
     * Listens for the borwser being scrolled and updates the navigator from fixed to absolute depending on the pay steps containers position on screen.
     * @private
     * @param {selector} $nav - Payment Step Navigator element.
     */

    _onWindowsScroll: function _onWindowsScroll($nav) {
      var _this = this;
      this.settings.endpoint = $('[' + this.attr.endPoint + ']').offset().top;
      var center = window.innerHeight / 2 + 180;
      $(window).scroll(function () {
        if ($(window).scrollTop() + center >= _this.settings.endpoint) {
          $nav.addClass(_this.classes.navUnstick);
        } else {
          $nav.removeClass(_this.classes.navUnstick);
        }
      });
    },
    /**
     * Get Navigation Step Key
     * Returns the key for the payment step. This is used to allow the navigator to target requested steps within the payment step container.
     * @private
     * @param {selector} $step - Each step within the payment step container.
     */

    _getNavigationStepKey: function _getNavigationStepKey($step) {
      return $step.attr(this.attr.payStep);
    },
    /**
     * Get Navigation Active Step
     * Returns the current active step on the payment step navigator.
     * @private
     * @param {selector} $steps - All steps within the payment step navigator.
     */

    _getNavigationActiveStep: function _getNavigationActiveStep($steps) {
      return $steps.find('.' + this.classes.navItemActive);
    },
    /**
     * Set Navigation Step Key
     * Sets the payment step key to each of the steps within the payment step navigator.
     * @private
     * @param {selector} $nav - Payment Step Navigator element.
     * @param {string} key - The key of the required payment step.
     */

    _setNavigationStepKey: function _setNavigationStepKey($nav, key) {
      var $navItem = $nav.find('.' + this.classes.navItem).last();
      $navItem.attr(this.attr.key, key);
    },
    /**
     * Set Back To Method Attr
     * Applys an attribute that when clicked will clear the current state of the payment process.
     * @private
     * @param {selector} $nav - Payment Step Navigator element.
     */

    _setBackToMethodAttr: function _setBackToMethodAttr($nav) {
      var step = $nav.find('[' + this.attr.key + '="PaymentMethod"]');
      step.attr(this.attr.backToMethod, '');
    },
    /**
     * Set Navigation Height
     * Sets a style height to the navigator to stop issues switches between fixed and absolute positioning.
     * @private
     * @param {selector} $nav - Payment Step Navigator element.
     */

    _setNavigationHeight: function _setNavigationHeight($nav) {
      $nav.attr('style', '');
      var height = $nav.height();
      $nav.css('height', height);
    },
    /**
     * Set Navigation Step Status
     * Sets the required statuses of the navgation steps depending on their selection.
     * @private
     * @param {selector} $nav - Payment Step Navigator element.
     * @param {selector} $step - Each step within the payment step container.
     */

    _setNavigationStepStatus: function _setNavigationStepStatus($nav, $step) {
      var $navItem = $nav.find('.' + this.classes.navItem).last();
      if ($step.hasClass(this.classes.payStepActive)) {
        this._setNavigationStepActive($navItem);
        this._setNavigationStepEnabled($navItem);
        this._setNavigationStepTabIndex($navItem);
      } else if ($step.hasClass(this.classes.payStepConfirmed)) {
        this._setNavigationStepEnabled($navItem);
        this._setNavigationStepTabIndex($navItem);
      } else if ($step.hasClass(this.classes.payStepVisited)) {
        this._setNavigationStepEnabled($navItem);
        this._setNavigationStepVisited($navItem);
        this._setNavigationStepTabIndex($navItem);
      }
      if ($step.hasClass(this.classes.payStepBlocked)) {
        this._setNavigationStepBlocked($navItem);
      }
    },
    /**
     * Set Navigation Step Header
     * Sets the header tooltip on each of the navigator steps.
     * @private
     * @param {selector} $nav - Payment Step Navigator element.
     * @param {selector} $step - Each step within the payment step container.
     */

    _setNavigationStepHeader: function _setNavigationStepHeader($nav, $step) {
      var $navHeaders = $nav.find('.' + this.classes.navItemHeader);
      var $stepHeader = $step.attr(this.attr.payStepTitle);
      $navHeaders.last().html($stepHeader);
    },
    /**
     * Set Navigation Step Active
     * Sets the requested step within the navigation to active.
     * @private
     * @param {selector} $navItem - The requested step within the navigator.
     */

    _setNavigationStepActive: function _setNavigationStepActive($navItem) {
      $navItem.addClass(this.classes.navItemActive);
      if ($navItem.hasClass(this.classes.navItemVisited)) {
        $navItem.removeClass(this.classes.navItemVisited);
      }
    },
    /**
     * Set Navigation Step Enabled
     * Sets the requested step within the navigation to enabled by removing any disabled classes.
     * @private
     * @param {selector} $navItem - The requested step within the navigator.
     */

    _setNavigationStepEnabled: function _setNavigationStepEnabled($navItem) {
      $navItem.removeClass(this.classes.navItemDisabled);
    },
    /**
     * Set Navigation Step TabIndex
     * Sets the tabindex attribute on the requested step within the navigator to 0 allowing users to tab to the step. This is for accessibility purposes.
     * @private
     * @param {selector} $navItem - The requested step within the navigator.
     */

    _setNavigationStepTabIndex: function _setNavigationStepTabIndex($navItem) {
      $navItem.attr('tabindex', '0');
    },
    /**
     * Set Navigation Step Visited
     * Sets the requested step on the navigator to visited if the user hasn't confirmed this step within the payment step container.
     * @private
     * @param {selector} $navItem - The requested step within the navigator.
     */

    _setNavigationStepVisited: function _setNavigationStepVisited($navItem) {
      $navItem.addClass(this.classes.navItemVisited);
    },
    /**
     * Set Navigation Step Blocked
     * Sets the requested step on the navigator to blocked if the user has returned to a previous step and made required details invalid.
     * @private
     * @param {selector} $navItem - The requested step within the navigator.
     */

    _setNavigationStepBlocked: function _setNavigationStepBlocked($navItem) {
      $navItem.addClass(this.classes.navItemBlocked);
    }
  };

  /**
   * Global callback function which by default all [data-paystep-navigation] triggers this plugin.
   * @method $.fn.app_paystepsnavigator()
   * @public
   * @constructor
   * @param {selector} $steps
   * @example $(element).app_paystepsnavigator(element);
   */

  $.fn.app_paystepsnavigator = function ($steps) {
    var plugin = this.data(dataKey);
    if (plugin instanceof PayStepsNavigator) {
      if (typeof $steps !== 'undefined') {
        plugin.init($steps);
      }
    } else {
      plugin = new PayStepsNavigator($steps);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);